module.exports = __webpack_public_path__ + "img/qrcode.415c068.png";